import React, { useEffect } from 'react'
import Alert from '@mui/material/Alert'

export interface IMessageState extends Pick<React.ComponentProps<typeof Alert>, 'severity'> {
  content: string
}

export interface IProps {
  message: IMessageState | null
}

export const HaynesProMessage: React.FC<IProps> = ({ message }: IProps) => {
  const [open, setOpen] = React.useState(!!message)

  // re-open whenever a new message is set
  useEffect(() => {
    setOpen(true)
  }, [message])
  const onClose = () => {
    setOpen(false)
  }

  return open && message ? (
    <Alert elevation={6} variant='filled' onClose={onClose} severity={message.severity}>
      {message.content}
    </Alert>
  ) : null
}

export default HaynesProMessage
